module.exports = __webpack_public_path__ + "static/04-take-action-b85b662d07ee9cc64a4a71bc48b58ac4.jpg";